import React, { useState } from "react";
import styled from "styled-components";
import { Tab, Tabs } from "react-bootstrap";
import { colors } from "utils";
import { AdminWeeklyReport } from "./AdminWeeklyReport";
import { AdminSessionHistory } from "./AdminSessionHistory";
import { AdminStudentActivity } from "./AdminStudentActivity";
import { AdminProficiency } from "./AdminProficiency";
import { AdminCollaborationTrend } from "./AdminCollaborationTrend";
import { AdminHeadlines } from "./AdminHeadlines";
import { AdminCollaborationHeadlines } from "./AdminCollaborationHeadlines";
import { LessonReportConsole } from "./LessonReportConsole/LessonReportConsole";
import { TeacherSearch } from "./CustomReport/TeacherSearch";
import { EducatorBanner } from "./CustomReport/EducatorBanner";

export const AdminWeeklyReportTabs = ({ adminUserData }) => {
  const [selectedEducator, setSelectedEducator] = useState(null);
  const [activeTab, setActiveTab] = useState("weekly-report");
  const [sharedClassId, setSharedClassId] = useState(null);

  const handleEducatorChange = (educator) => {
    setSelectedEducator(educator);
    setSharedClassId(null);
  };

  if (!selectedEducator) {
    return <TeacherSearch onTeacherSelected={handleEducatorChange} />;
  }

  return (
    <div>
      <EducatorBanner
        teacher={selectedEducator}
        onBack={() => handleEducatorChange(null)}
      />
      <TabsContainer>
        <Tabs activeKey={activeTab} onSelect={setActiveTab}>
          <Tab unmountOnExit eventKey="weekly-report" title="Class Insights">
            <AdminWeeklyReport
              selectedEducator={selectedEducator}
              onEducatorChange={setSelectedEducator}
              sharedClassId={sharedClassId}
              onClassChange={setSharedClassId}
            />
          </Tab>
          <Tab unmountOnExit eventKey="session-history" title="Session History">
            <AdminSessionHistory
              selectedEducator={selectedEducator}
              sharedClassId={sharedClassId}
              onClassChange={setSharedClassId}
            />
          </Tab>
          <Tab unmountOnExit eventKey="student-activity" title="Student Activity">
            <AdminStudentActivity
              selectedEducator={selectedEducator}
              sharedClassId={sharedClassId}
              onClassChange={setSharedClassId}
            />
          </Tab>
          {adminUserData?.can_access_user_admin && (
            <Tab unmountOnExit eventKey="proficiency" title="Proficiency">
              <AdminProficiency
                selectedEducator={selectedEducator}
                sharedClassId={sharedClassId}
                onClassChange={setSharedClassId}
              />
            </Tab>
          )}
          {adminUserData?.can_access_user_admin && (
            <Tab unmountOnExit eventKey="collaboration-trend" title="Collaboration Trend">
              <AdminCollaborationTrend
                selectedEducator={selectedEducator}
                sharedClassId={sharedClassId}
                onClassChange={setSharedClassId}
              />
            </Tab>
          )}
          {adminUserData?.can_access_user_admin && (
            <Tab eventKey="headlines" title="Headlines: Math Proficiency">
              <AdminHeadlines
                selectedEducator={selectedEducator}
                sharedClassId={sharedClassId}
                onClassChange={setSharedClassId}
                adminUserData={adminUserData}
              />
            </Tab>
          )}
          {adminUserData?.can_access_user_admin && (
            <Tab eventKey="collaboration-headlines" title="Collaboration Headlines">
              <AdminCollaborationHeadlines
                selectedEducator={selectedEducator}
                sharedClassId={sharedClassId}
                onClassChange={setSharedClassId}
                adminUserData={adminUserData}
              />
            </Tab>
          )}
          {adminUserData?.can_access_user_admin && (
            <Tab mountOnEnter eventKey="lesson-report-console" title="Lesson Report Console">
              <LessonReportConsole key={selectedEducator.id} selectedEducator={selectedEducator} adminUserData={adminUserData} />
            </Tab>
          )}
        </Tabs>
      </TabsContainer>
    </div>
  );
};

const TabsContainer = styled.div`
  padding: 24px;
  background-color: ${colors.milkGlass200};
  min-height: calc(100vh - 140px);
`;
